import React from "react";
import ReactPaginate from 'react-paginate';

const Pagination = ({pageCount, page, setPage}) => {
    if(pageCount === 1){
        return <></>;
    }

    return (
        <>
            <p className="pages-total">Página {page} de {pageCount}</p>
            <div className="pagination-container">
                <button disabled={page === 1} onClick={() => setPage(1)}>Primeira</button>
                <ReactPaginate
                    forcePage={page -1}
                    pageCount={pageCount}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={0}
                    previousLabel="<"
                    nextLabel=">"
                    containerClassName={`pagination`}
                    onPageChange={(e) => setPage(e.selected + 1)}
                />
                <button disabled={page === pageCount} onClick={() => setPage(pageCount)}>Última</button>
            </div>
        </>
    );
}

export default Pagination